import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { BaseMapProvider } from './context/BaseMapContext'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <BaseMapProvider>
        <App />
      </BaseMapProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
